import * as React from "react";
// @ts-ignore
import classnames from "classnames";
import { Props, State } from "./types";
import "./styles.scss";

export class List extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isClick: false,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const list = document.querySelectorAll(".list__item");

    if (this.props.isDisabled) {
      for (let i = 0; i < list.length; i += 1) {
        list[i]?.classList?.remove("list__item__isActive");
      }
    }

    list[0]?.classList?.add("list__item__isActive");
  }

  componentDidUpdate(prevProps: Props) {
    const list = document.querySelectorAll(".list__item");

    if (this.props.isDisabled !== prevProps.isDisabled) {
      for (let i = 0; i < list.length; i += 1) {
        list[i]?.classList?.remove("list__item__isActive");
      }
    }
  }

  handleClick(pEvt: any) {
    const list = document.querySelectorAll(".list__item");

    for (let i = 0; i < list.length; i += 1) {
      list[i]?.classList?.remove("list__item__isActive");
    }
    pEvt.currentTarget.classList?.add("list__item__isActive");
  }

  render() {
    const { data, title, onClick } = this.props;

    return (
      <div className="list">
        <h2 className="list__title">{title}</h2>
        <div className="list__items">
          {Array.isArray(data) &&
            data.map((d, index: number) => (
              <div
                key={`${d.title}__${index}`}
                className={classnames(
                  "list__item",
                  (index === 0 || d?.title === "Nouvel utilisateur") &&
                  "list__item__isActive"
                )}
                onClick={(pEvt) => {
                  onClick(d);
                  this.setState({
                    isClick: !this.state.isClick,
                  });

                  this.handleClick(pEvt);
                }}
              >
                <div className="list__item__info">
                  <div className="list__item__media">
                    {d.media ? (
                      <img src={d.media} />
                    ) : (
                        <div className="list__item__withoutMedia">
                          {d.title?.split(" ")[0][0] || ""}
                        </div>
                      )}
                  </div>
                  <div className="list__item__desc">
                    <h3 className="list__item__desc__title">{d.title}</h3>
                    {d.subtitle && (
                      <h4 className="list__item__desc__subtitle">
                        {d.subtitle}
                      </h4>
                    )}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}
